import React from "react";
import Input from "antd/lib/input";
import { useTheme } from "@/components/ThemeProvider";

export default function TextAreaField({ form, field, ...otherProps }) {
  const { isDarkMode } = useTheme();
  return <Input.TextArea {...otherProps} className={isDarkMode ? "dark-mode" : ""} />;
}
